export class GtmService {
  /**
   * Pushes an event.
   *
   * @param      {string}  eventName        The event name
   * @param      {object}  eventProperties  The event properties
   */
  pushEvent(eventName: string, eventProperties): void {
    if (typeof window !== 'undefined' && window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push(Object.assign({ event: eventName }, eventProperties));
    } else if (typeof window !== 'undefined') {
      console.error('dataLayer is not defined');
    }
  }

  /**
   * Tracks a menu click
   *
   * @param      {string}  linkName  The link name
   * @param      {string}  target    The target
   */
  trackMenuClick(linkName: string, target: string): void {
    this.pushEvent('menu', {
      event_name: 'menu',
      event_action: 'click',
      link_name: linkName || '',
      page_target: target || '',
    });
  }

  /**
   * Tracks an advice card click
   *
   * @param      {string}  category  The category
   * @param      {string}  title     The title
   * @param      {string}  pageUrl   The page url
   */
  trackAdviceCard(category: string, title: string, pageUrl: string): void {
    this.pushEvent('advice', {
      event: 'generic_event',
      event_category: 'engagement',
      event_action: 'click',
      event_label: 'advice',
      event_name: 'generic_event',
      category,
      advice: title || '',
      page_url: pageUrl || '',
    });
  }

  /**
   * Tracks a login event
   *
   * @param      {User}  user      The user
   * @param      {string}  category  The category (eg. email, google, facebook, etc.)
   * @param      {string}  pageUrl   The page url
   */
  trackLogin(user, category: string, pageUrl: string): void {
    this.pushEvent('login', {
      event_category: 'engagement',
      event_action: 'submit',
      event_label: 'login',
      event_name: 'login',
      origin: pageUrl,
      method: category,
      email: user?.email,
      user_id: user?.id,
    });
  }

  /**
   * Tracks a failed login event
   *
   * @param      {string}  category  The category (eg. email, google, facebook,
   *                                 etc.)
   * @param      {string}  pageUrl   The page url
   */
  trackFailedLogin(category: string, pageUrl: string): void {
    this.pushEvent('login_failed', {
      origin: pageUrl,
      method: category,
    });
  }

  /**
   * Tracks the signup event
   *
   * @param      {User}  user      The user
   */
  trackSignup(user): void {
    this.pushEvent('form', {
      event_category: 'form',
      event_action: 'submit',
      event_label: 'sign_up',
      event_name: 'sign_up',
      origin,
      user_data: {
        firstName: user?.firstName,
        lastName: user?.lastName,
        email: user?.email,
        salutation: user?.salutation,
        dateOfBirth: user?.dateOfBirth,
      },
      newsletter: user?.newsletter,
    });
  }
}
